<template>
  <div id="app" @click.right.prevent>
    <component :is="layout" v-if="layout" />
    <AppLoading ref="loading" />
  </div>
</template>

<script>
import AppLoading from "./components/AppLoading.vue";

export default {
  components: {
    AppLoading
  },
  metaInfo() {
    return {
      title: "Test - Questions Bank"
    };
  },
  computed: {
    layout() {
    //    console.log(this.$route);
      return this.$route.meta.layout;
    }
  },
  mounted() {
    this.$root.$loading = this.$refs.loading;

    // check nếu this.$route.name === "TryExam" thì gọi 2 file js này: /public/libs/recorder.js, /public/libs/lame.min.js
    // const loadScriptOnce = (src, globalName) => {
    //     if (window[globalName]) return;
    //     const s = document.createElement("script");
    //     s.src = src;
    //     s.async = true;
    //     document.head.appendChild(s);
    // };

    // const checkAndLoadScripts = () => {
    //     if (this.$route.name === "TryExam") {
    //     loadScriptOnce("/libs/recorder.js", "Recorder");
    //     loadScriptOnce("/libs/lame.min.js", "lamejs");
    //     }
    // };

    // // Gọi lần đầu khi mount
    // checkAndLoadScripts();

    // // Theo dõi route thay đổi nếu là SPA
    // this.$watch('$route.name', (newName) => {
    //     if (newName === "TryExam") {
    //     loadScriptOnce("/libs/recorder.js", "Recorder");
    //     loadScriptOnce("/libs/lame.min.js", "lamejs");
    //     }
    // });
    // End: check nếu this.$route.name === "TryExam" thì gọi 2 file js này: /public/libs/recorder.js, /public/libs/lame.min.js

    // kiem tra keyboard de ngan khong cho nguoi dung mo f12

    // function ctrlShiftKey(e, keyCode) {
    //     return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
    // }
    // document.onkeydown = (e) => {

    // // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
    //     if (
    //         e.keyCode === 123 ||
    //         ctrlShiftKey(e, 'I') ||
    //         ctrlShiftKey(e, 'J') ||
    //         ctrlShiftKey(e, 'C') ||
    //         (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
    //     )
    //     return false;
    // };
    // // END - kiem tra keyboard de ngan khong cho nguoi dung mo f12

    // // chan boi den van ban
    // addEventListener("selectstart", event => event.preventDefault());
    // // end - chan boi den van ban
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import "/assets/scss/app.scss";
</style>
